import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IAmountState } from './amount.state';

export class AmountSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly amountState = (state: IRootState): IAmountState => {
    return state.amount as IAmountState;
  };

  static readonly model = createSelector(AmountSelectors.amountState, (amount: IAmountState) => {
    return amount.model;
  });

  static readonly data = createSelector(AmountSelectors.amountState, (amount: IAmountState) => {
    return amount.data;
  });
}
